import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export const scrollToComprar = (e?: React.MouseEvent) => {
  if (e) e.preventDefault();
  const el = document.getElementById('comprar');
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth'
    });
  }
};
export const CTAButton = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => <a href="https://checkout.DigitalNek.shop/cart/48116818772203:1" className={`block w-full bg-[#F47B20] hover:bg-[#e06a1b] text-white font-extrabold py-4 px-8 rounded-xl shadow-[0_4px_14px_0_rgba(244,123,32,0.39)] transform transition-all hover:scale-[1.02] active:scale-[0.98] text-lg sm:text-xl md:text-2xl text-center ${className}`} data-id="element-179">
    {children}
  </a>;
export const ProductImage = ({
  className = ''
}: {
  className?: string;
}) => <img src="https://cdn.magicpatterns.com/uploads/7rn1f2Fass2bJCtkmfynUa/mock_up_moticidad.png" alt="Motricidad en Niños" className={`w-full max-w-sm mx-auto rounded-lg shadow-2xl cursor-pointer transform transition-transform hover:scale-105 ${className}`} onClick={scrollToComprar} data-id="element-180" />;
export const CheckItem = ({
  children
}: {
  children: React.ReactNode;
}) => <div className="flex items-start gap-3 mb-4" data-id="element-181">
    <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-182" />
    <p className="text-lg leading-relaxed font-medium" data-id="element-183">{children}</p>
  </div>;
export const CrossItem = ({
  title,
  desc
}: {
  title: string;
  desc: string;
}) => <div className="flex items-start gap-3 mb-6" data-id="element-184">
    <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-185" />
    <div data-id="element-186">
      <h4 className="text-lg font-bold text-red-600 mb-1" data-id="element-187">{title}</h4>
      <p className="text-gray-700 leading-relaxed" data-id="element-188">{desc}</p>
    </div>
  </div>;